module.exports = __webpack_public_path__ + "img/soft-grove-study-2.5b7a2cfa.jpeg";